import { render, staticRenderFns } from "./DataBoard.vue?vue&type=template&id=7819a556&scoped=true&"
import script from "./DataBoard.vue?vue&type=script&lang=js&"
export * from "./DataBoard.vue?vue&type=script&lang=js&"
import style0 from "./DataBoard.vue?vue&type=style&index=0&id=7819a556&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7819a556",
  null
  
)

export default component.exports